import toast from 'react-hot-toast';
export const openToManyRequestToast = () => {
  toast.error('تعداد درخواست‌های شما بیش از حد مجاز است. لطفا دقایقی دیگر دوباره تلاش کنید.', {
    duration: 3000,
    id: 'notify-me-toast',
    style: {
      maxWidth: 'fit-content'
    }
  });
};